import Bugsnag from '@bugsnag/js'

type LaunchLinkRouteAction = {
  match: RegExp[]
  generateLaunchLink: (currentUrl?: URL) => string
}

const getRedirectTo = () => {
  if (!window.encodedRedirectTo) {
    return null
  }

  try {
    return new URL(atob(window.encodedRedirectTo))
  } catch {
    Bugsnag.notify({ name: 'getRedirectTo', message: `App attempted to redirect to ${window.encodedRedirectTo}` })
  }

  return null
}

/**
 * Try to match redirect routes to launch links
 * Order matters!
 */
export const webUrlToLaunchLinkHandler: LaunchLinkRouteAction[] = [
  {
    match: [/\/f\//, /\/flow\//],
    generateLaunchLink: (currentUrl?: URL) => {
      const flowPath = currentUrl?.pathname.replace(/^\/[^/]+\/(.*)$/, '$1')
      return '/f/' + flowPath
    },
  },
  {
    match: [/taxes.cash/],
    generateLaunchLink: () => {
      const { pathname = '', search = '' } = getRedirectTo() ?? {}
      return '/launch/taxes' + pathname + search
    },
  },
  {
    match: [/account\/activity/],
    generateLaunchLink: () => '/launch/activity',
  },
  {
    match: [/account\/settings/],
    generateLaunchLink: () => '/launch/profile',
  },
  {
    match: [/account\/money/],
    generateLaunchLink: () => '/launch/money',
  },
  {
    match: [/account\/pay-and-request/],
    generateLaunchLink: () => '/launch/payment-pad',
  },
]
